import { useLocale } from '@hooks/useLocale';
import { Group, Text } from '@mantine/core';
import React from 'react';

const TestUserSubscriptionPreferences = () => {
    const { t } = useLocale();

    return (
        <Group className="gap-2 p-3 mb-4 bg-white rounded-lg border border-gray-250">
            <Text className="text-sm font-semibold text-gray-800">
                {t('subscription_preference.user_preference_warning')}
            </Text>
            <Text className="text-sm font-medium text-gray-600">
                {t(
                    'subscription_preference.user_preference_warning_description',
                )}
            </Text>
        </Group>
    );
};

export default React.memo(TestUserSubscriptionPreferences);
